import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";
import MDTypography from "common/components/MD/MDTypography";


// Data

import { NoneFilter } from "../expo_richieste_admin/NoneFilter";
import { useFarFieraUIController } from "common/context/FarFieraContext";
import UtilityService from "services/API/utility/UtilityService";
import AuthService from "services/API/Auth/AuthService";
import NotificheDataTable from "./NotificheDataTable";
import MDInput from "common/components/MD/MDInput";



function NotificheBox() {



  const [menu, setMenu] = useState(null);

  const openMenu = ({ currentTarget }) => setMenu(currentTarget);
  const closeMenu = () => setMenu(null);

  const [lista_notifiche, setLista_notifiche] = useState([]);
  const [ffcontroller] = useFarFieraUIController();
  const { manifestazione } = ffcontroller;

  const[data_da,setData_da]=useState();

  useEffect(() => {

    fetchInitialData2();
    async function fetchInitialData2() {
      const user = AuthService.getCurrentUser();
      //   console.log(user);
      if (user) {
        const response = await UtilityService.getAllNotifiche(user.roles[0], user.id,manifestazione);
       // console.log(response);
        // response.errors ? console.log(response.errors) : setLista_notifiche([...response.data]);                

        if (!response.error && response.data) {
          console.log(response.data);
          const nuove = response.data;
          setLista_notifiche(nuove);

        }
      }

    }

  }, []);


  const notificheAttributes = [];

  if (Array.isArray(lista_notifiche) && lista_notifiche.length > 0) {

    lista_notifiche.forEach(n => {
      console.log(":::" + n.icona)
      let icon = <Icon>{n.icona}</Icon>;

      notificheAttributes.push({

        id_notifica: n.id_notifica,
        messaggio: n.messaggio,
        data_inserimento: n.data_inserimento,
        icona: icon,
        id_utente: n.id_utente,

      })

    })
  }


  const ppTableData = {
    rows: notificheAttributes,

    columns: [
      { Header: "", accessor: "icona", Filter: NoneFilter, width: "4%", align: "left", id: "notifica_0" },
      { Header: "Data", accessor: "data_inserimento", Filter: NoneFilter, width: "21%", align: "left", id: "notifica_1" },
      { Header: "Messaggio", accessor: "messaggio", Filter: NoneFilter, align: "left", width: "75%", id: "notifica_2" },

    ],



  };

  const mypagination = { color: 'success', variant: "contained" };



  return (
    <Card>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
        <MDBox>
          <MDTypography variant="h6" gutterBottom sx={({ palette: { brand } }) => ({ color: brand.main })}>
            Ultime Notifiche
          </MDTypography>
        </MDBox>
        <MDBox color="text" px={2}>
            
        </MDBox>

      </MDBox>
      <MDBox>
          <NotificheDataTable
                          table={ppTableData}
                          nome_tabella="notifiche"
                          isSorted={true}
                          entriesPerPage={true}
                          showTotalEntries={true}
                          pagination={mypagination}
                          noEndBorder
                          responsive={true}
                          canExport={AuthService.isAdmin()?true:false}
                          enableColumnFilters={true}
                          chiamante='dashboard'
                   
                        />
    
      </MDBox>
    </Card>
  );
}

export default NotificheBox;
